<template>
  <transition name="fade">
    <div v-if="isPopupVisible" class="main-menu-mobile" :aria-hidden="!isPopupVisible">
      <transition name="slide-up">
        <div class="main-menu-mobile__container">
          <div class="balance-group" v-if="!getUserInfo.organizationId">
            <AccountBalance />
          </div>
          <MobileMenuSkeleton :is-loading="!isUserDataReady">
            <MobileMenu :routes="routes" />
          </MobileMenuSkeleton>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import MobileMenu from './mobile-menu';
import MobileMenuSkeleton from './mobile-menu-skeleton';
import { AccountBalance } from '@/features/account-balance';
import { POPUP_EVENTS, popupView } from '@/shared/ui/popup';
import { MOBILE_MENU_EVENTS, MOBILE_MENU_USER_PROFILE_EVENTS } from '@/widgets/app-main-menu';

export default {
  props: {
    isUserDataReady: {
      type: Boolean,
      required: true,
    },
    routes: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.$eventBus.$on(POPUP_EVENTS.CLOSE, this.handleClosePopup);
    this.$eventBus.$on(MOBILE_MENU_EVENTS.MOBILE_MENU_OPEN, this.open);
    this.$eventBus.$on(MOBILE_MENU_EVENTS.MOBILE_MENU_CLOSE, this.close);
    this.$eventBus.$on(MOBILE_MENU_USER_PROFILE_EVENTS.LOGOUT, this.logout);
  },
  beforeDestroy() {
    this.$eventBus.$off(POPUP_EVENTS.CLOSE, this.handleClosePopup);
    this.$eventBus.$off(MOBILE_MENU_EVENTS.MOBILE_MENU_OPEN, this.open);
    this.$eventBus.$off(MOBILE_MENU_EVENTS.MOBILE_MENU_CLOSE, this.close);
    this.$eventBus.$off(MOBILE_MENU_USER_PROFILE_EVENTS.LOGOUT, this.logout);
  },
  mixins: [ popupView ],
  components: { MobileMenu, AccountBalance, MobileMenuSkeleton },
  computed: {
    ...mapGetters('currentUserModule', ['getUserInfo']),
  },
  methods: {
    open() { this.openPopup(); },
    close() { this.closePopup(this.getPopupId); },
    handleClosePopup(data) {
      if (data?.id === this.getPopupId && !data?.isVisible) {
        this.closePopup();
      }
    },
    logout() {
      this.$store.dispatch('LOGOUT')
        .then(() => {
          this.$store.dispatch('RESET_CLIENT_BONUS_STATE');
          this.$store.dispatch('RESET_TRANSACTION_STATE');
          this.$store.dispatch('RESET_PAID_ORDERS_STATE');
          window.location.href = this.$router.resolve('/login')?.href;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-menu-mobile {
  position: fixed;
  top: 83px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: #FFFFFF;
  padding-right: 12px;
  z-index: 10600;
  overflow-y: auto;

  &__container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-up-enter-active, .slide-up-leave-active {
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  }

  .slide-up-enter, .slide-up-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }
}

.balance-group {
  padding: 16px;
}
</style>
